import { Box, Paper, Typography } from "@mui/material";
import { BarChart3 } from "lucide-react";
import { useMemo } from "react";
import ApexCharts from "react-apexcharts";

interface UserData {
  user: {
    _id: string;
    name: string;
  };
  deals: number;
  leads: number;
  conversionRate: number;
}

interface Props {
  data: UserData[];
}

export default function HorizontalStackedBar({ data }: Props) {
  const series = useMemo(() => {
    return [
      {
        name: "Primer Contacto",
        data: data.map((d) => d.leads),
      },
      {
        name: "Contrato Firmado",
        data: data.map((d) => d.deals),
      },
    ];
  }, [data]);

  const options = useMemo(
    () => ({
      chart: {
        type: "bar",
        stacked: true,
        height: 400,
        toolbar: { show: true },
      },
      plotOptions: {
        bar: {
          horizontal: true,
          barHeight: "50%",
        },
      },
      xaxis: {
        categories: data.map((d) => d.user.name),
        title: { text: "Cantidad" },
      },
      yaxis: {
        title: { text: "Usuarios" },
      },
      tooltip: {
        y: {
          formatter: (val: number) => val.toString(),
        },
      },
      legend: {
        position: "bottom",
        horizontalAlign: "left",
      },
      colors: ["#345E8D", "#5188C8"], // deals y leads
    }),
    [data]
  );

  return (
    <Paper elevation={3}>
      <Box display="flex" alignItems="center" gap={1} mb={1} sx={{ p: 2 }}>
        <BarChart3 size={24} />
        <Typography variant="h6">
          Top 10 Asesores por seguimiento y conversión
        </Typography>
      </Box>

      <ApexCharts
        options={options as any}
        series={series}
        type="bar"
        height={400}
      />
    </Paper>
  );
}
